var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientRequests && _vm.isUpdate)?_c('div',[_c('user-requests',{attrs:{"first_name":_vm.client.first_name,"last_name":_vm.client.last_name,"requests":_vm.clientRequests},on:{"done":_vm.done}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }